module.exports = __webpack_public_path__ + "static/media/spenmo-logo-orange.54fb17ae.svg";